import { createHashHistory } from 'history';

const HISTORY = createHashHistory();

export default HISTORY;
